import React from 'react';
import './TabletSubmenu.css';
import {
  Link,
} from 'react-router-dom';

function TabletSubmenu(props) {
    return (
        <ul className='tabletSubmenu'>
            {props.subMenu.map((item, index) => {
                const { value, link, sub, subClassName } = item; 
          return (
              <Link to={link} key={index}>
                  <li>{value}
                      {sub[0].value && <ul className={subClassName}>
                      {sub.map((item, index) => {
                          return <li key={index}>{item.value}</li>
                      })}
                      </ul>}
                </li>
              </Link>
          )
        })}
      </ul>
 )
  }

export default (TabletSubmenu);



// WEBPACK FOOTER //
// ./src/components/Home/HomePageHeader/TabletNavbar/TabletSubmenu/TabletSubmenu.jsx